import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

import React from 'react';
import { MapPin, Building2, HelpCircle } from 'lucide-react';
import { CountryFlag } from '@/lib/country-flags';

interface LocationData {
  id: string;
  name: string;
  code: string;
  views: number;
  percentage: number;
  flag?: string;
}

interface LocationsListProps {
  data: LocationData[];
  colors: string[];
  type?: 'country' | 'state' | 'city';
}

export function LocationsList({ data, colors, type = 'country' }: LocationsListProps) {
  useLanguage();
  // Verifica se o valor é desconhecido ou inválido
  const isUnknown = (value?: string) => {
    if (!value) return true;
    const lowerValue = value.toLowerCase().trim();
    return lowerValue === 'desconhecido' ||
           lowerValue === 'unknown' ||
           lowerValue === 'n/a' ||
           lowerValue === '-' ||
           lowerValue === 'null' ||
           lowerValue === 'undefined';
  };

  const getLocationIcon = () => {
    switch (type) {
      case 'city':
        return <MapPin className="h-4 w-4 text-[#7E8492]" />;
      case 'state':
        return <MapPin className="h-4 w-4 text-[#7E8492]" />;
      default:
        return null;
    }
  };

  return (
    <div className="space-y-2.5">
      {data.slice(0, 4).map((item, index) => (
        <div 
          key={item.id} 
          className="flex items-center justify-between bg-[#F7F9FF] border border-[#E2E8FF] rounded-[12px] px-[16px] py-[12px] min-h-[54px] transition-all duration-150 hover:bg-[#F1F5FF]"
          style={{ boxShadow: '0px 2px 6px rgba(0,0,0,0.04)' }}
        >
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 rounded-lg bg-[#F2F4F7] flex items-center justify-center overflow-hidden">
              {isUnknown(item.name) || (type === 'country' && isUnknown(item.code)) ? (
                <HelpCircle className="h-5 w-5 text-[#9CA3AF]" />
              ) : type === 'country' ? (
                <CountryFlag country={item.code || item.name} size={20} />
              ) : (
                getLocationIcon()
              )}
            </div>
            <div>
              <p className="text-[13px] font-medium text-[#1A1A1A]">{item.name}</p>
              <p className="text-[12px] font-normal text-[#6B7280]">{item.percentage}{translateInterfaceText("% das visualizações")}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-[14px] font-semibold text-[#1A1A1A]">
              {item.views.toLocaleString(getInterfaceLanguage())}
            </p>
            <p className="text-[11px] text-[#9CA3AF]">{translateInterfaceText("visualizações")}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
